<template>
    <section class="section breadcrumb-area bg-overlay d-flex align-items-center">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <!-- Breamcrumb Content -->
                        <div class="breadcrumb-content d-flex flex-column align-items-center text-center">
                            <h2 class="text-white text-capitalize">{{data.title}}</h2>
                            <h4 class="text-white text-capitalize">{{data.text}}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    props: ['data']
}
</script>

<style>

</style>